import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  getClubPackageByClubId,
  updateClubPackageItems,
  getClubPackageItems
} from './api';
import {
  GET_CLUB_PACKAGE_BY_CLUBID_REQUEST,
  CLUB_PACKAGE_OBJECT_REQUESTING,
  GET_CLUB_PACKAGE_SUCCESS,
  RESET_CLUB_PACKAGE_ISFETCHING,
  GET_DYNAMIC_PRICING_CLUB_PACKAGE_REQUEST,
  UPDATE_DYNAMIC_PRICING_CLUB_PACKAGE_REQUEST
} from './constants';

function* getByClubId(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_PACKAGE_OBJECT_REQUESTING });
    try {
      const response = yield call(getClubPackageByClubId, action.clubId);
      yield put({ type: GET_CLUB_PACKAGE_SUCCESS, payload: response.data });
      return response.data;
    } catch (err) {
      if (err.response && err.response.status === 404) {
        yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
      } else {
        throw new Error(err);
      }
    }
    return null;
  } catch (error) {
    yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

function* getDynamicClubPackagePricing(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_PACKAGE_OBJECT_REQUESTING });
    try {
      const response = yield call(getClubPackageItems, action.shipmentId);
      yield put({ type: GET_CLUB_PACKAGE_SUCCESS, payload: response.data });
      return response.data;
    } catch (err) {
      if (err.response && err.response.status === 404) {
        yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
      } else {
        throw new Error(err);
      }
    }
    return null;
  } catch (error) {
    yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

function* updateDynamicClubPackagePricing(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_PACKAGE_OBJECT_REQUESTING });
    try {
      const response = yield call(
        updateClubPackageItems,
        action.shipmentId,
        action.items
      );
      yield put({ type: GET_CLUB_PACKAGE_SUCCESS, payload: response.data });
      return response.data;
    } catch (err) {
      if (err.response && err.response.status === 404) {
        yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
      } else {
        throw new Error(err);
      }
    }
    return null;
  } catch (error) {
    yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

function* watchList() {
  yield takeLatest(GET_CLUB_PACKAGE_BY_CLUBID_REQUEST, getByClubId);
  yield takeLatest(
    GET_DYNAMIC_PRICING_CLUB_PACKAGE_REQUEST,
    getDynamicClubPackagePricing
  );
  yield takeLatest(
    UPDATE_DYNAMIC_PRICING_CLUB_PACKAGE_REQUEST,
    updateDynamicClubPackagePricing
  );
}

export default function* clubSagas() {
  yield all([watchList()]);
}
